export class HygienaAuthError extends Error {
  name = "HygienaAuthError";
}

/** @param {string} value */
export function escapeHtml(value) {
  return value
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;");
}

/**
 * @template {Record<string, unknown>} T
 * @param {T} obj
 * @returns {(keyof T)[]}
 */
export function getObjectKeys(obj) {
  return /** @type {(keyof T)[]} */ (Object.keys(obj));
}

/**
 * @param {string} value
 * @param {HTMLElement} element
 */
export function applyHref(value, element) {
  if (element instanceof HTMLAnchorElement) {
    element.href = value;
  }
}

/**
 * @param {string} value
 * @param {HTMLElement} element
 */
export function applySrc(value, element) {
  if (element instanceof HTMLImageElement) {
    element.src = value;
  }
}

/**
 * @param {string} value
 * @param {HTMLElement} element
 */
export function applyDisabled(value, element) {
  if (element instanceof HTMLFieldSetElement) {
    element.disabled = booleanAttributeToBoolean(value);
  }
}

/**
 * @param {string} value
 * @param {HTMLElement} element
 */
export function applyPlaceholder(value, element) {
  if (element instanceof HTMLInputElement) {
    element.placeholder = value;
  }
}

/**
 * @param {string} value
 * @param {HTMLElement} element
 */
export function applyAlt(value, element) {
  if (element instanceof HTMLImageElement) {
    element.alt = value;
  }
}

/**
 * @param {string} attribute
 * @param {string} value
 * @param {HTMLElement} element
 */
export function applyCustomAttribute(attribute, value, element) {
  element.setAttribute(attribute, value);
}

/**
 * @param {string} property
 * @param {string} value
 * @param {HTMLElement} element
 */
export function applyCustomStyleProperty(property, value, element) {
  element.style.setProperty(property, value);
}

/**
 * @param {string | null | undefined} value
 * @param {boolean} [fallback]
 * @returns {boolean}
 */
export function booleanAttributeToBoolean(value, fallback = false) {
  if (value === null || value === undefined) return fallback;
  return value?.toLowerCase() === "true" || value === "";
}
